let zulinList = [
	{
		"rentMachineId": 44,
		"traderId": 4764,
		"stewardId": null,
		"stewardName": null,
		"stewardTel": null,
		"uniqueId": "ZL20234204",
		"title": "履带吊",
		"contactPerson": "李浩杰",
		"contactTel": "13028380808",
		"typeId": 111,
		"typeName": null,
		"brandId": 117,
		"brandName": null,
		"modelId": 475,
		"modelName": null,
		"displayTime": 3800,
		"price": 0,
		"isFaceToFace": 0,
		"frameNumber": "",
		"province": "西藏自治区",
		"provinceId": 13,
		"city": "昌都市",
		"cityId": 19102,
		"district": "八宿县",
		"districtId": 19115,
		"address": "西藏自治区-昌都市-八宿县",
		"detailAddress": "邦达机场附近",
		"location": "97.11789390047706,30.554593179006269",
		"pictures": "http://image.hudiejx.com/rent/20230403/ed9e8ade878d4b7b9ae53c572cb65faf.jpg",
		"status": 2,
		"stewardStatus": 1,
		"remark": "中联履带吊zcc-850v",
		"username": "Dɪsᴀᴘᴘᴇᴀʀ .",
		"statusName": null,
		"isOwn": null,
		"isBelongSteward": null,
		"distance": null,
		"isAppointed": null,
		"isApplied": null,
		"createTime": "2023-04-03 15:48:38",
		"updateTime": "2023-04-03 15:48:53"
	}, {
		"rentMachineId": 43,
		"traderId": 4225,
		"stewardId": null,
		"stewardName": null,
		"stewardTel": null,
		"uniqueId": "ZL20238212",
		"title": "徐工xr280重庆地区出租",
		"contactPerson": "周先生",
		"contactTel": "18580701460",
		"typeId": 34,
		"typeName": null,
		"brandId": 1656,
		"brandName": null,
		"modelId": 1675,
		"modelName": null,
		"displayTime": 5000,
		"price": 12,
		"isFaceToFace": 1,
		"frameNumber": "",
		"province": "重庆市",
		"provinceId": 12,
		"city": "重庆城区",
		"cityId": 18038,
		"district": "江北区",
		"districtId": 18050,
		"address": "重庆市-重庆城区-江北区",
		"detailAddress": "江北街道11号",
		"location": "107.400767775869,29.726593628476299",
		"pictures": "http://image.hudiejx.com/rent/20230321/c5734537d330415fb93f45d81ea6b616.jpg",
		"status": 5,
		"stewardStatus": 1,
		"remark": "好设备 价格优惠",
		"username": "工地包工头",
		"statusName": null,
		"isOwn": null,
		"isBelongSteward": null,
		"distance": null,
		"isAppointed": null,
		"isApplied": null,
		"createTime": "2023-03-21 10:26:02",
		"updateTime": "2023-04-11 17:58:48"
	}, {
		"rentMachineId": 42,
		"traderId": 14309,
		"stewardId": null,
		"stewardName": null,
		"stewardTel": null,
		"uniqueId": "ZL20233684",
		"title": "旋挖出租",
		"contactPerson": "何奕",
		"contactTel": "15178896352",
		"typeId": 34,
		"typeName": null,
		"brandId": 1656,
		"brandName": null,
		"modelId": 1657,
		"modelName": null,
		"displayTime": 1000,
		"price": 1,
		"isFaceToFace": 0,
		"frameNumber": "",
		"province": "重庆市",
		"provinceId": 12,
		"city": "重庆城区",
		"cityId": 18038,
		"district": "渝北区",
		"districtId": 18055,
		"address": "重庆市-重庆城区-渝北区",
		"detailAddress": "海领市场17号",
		"location": "106.66015171366274,29.748124216333193",
		"pictures": "http://image.hudiejx.com/rent/20230316/c3918e1524204038b200b4a8565febf2.jpeg",
		"status": 5,
		"stewardStatus": 1,
		"remark": "旋挖机8八成新，有保险。",
		"username": "何奕15178896352",
		"statusName": null,
		"isOwn": null,
		"isBelongSteward": null,
		"distance": null,
		"isAppointed": null,
		"isApplied": null,
		"createTime": "2023-03-16 16:07:43",
		"updateTime": "2023-04-11 17:58:24"
	},
	{
		"rentMachineId": 41,
		"traderId": 24,
		"stewardId": null,
		"stewardName": null,
		"stewardTel": null,
		"uniqueId": "ZL20238149",
		"title": "徐工320E",
		"contactPerson": "李思",
		"contactTel": "15157198112",
		"typeId": 34,
		"typeName": null,
		"brandId": 1656,
		"brandName": null,
		"modelId": 3850,
		"modelName": null,
		"displayTime": 5000,
		"price": 12,
		"isFaceToFace": 1,
		"frameNumber": "",
		"province": "四川省",
		"provinceId": 30,
		"city": "绵阳市",
		"cityId": 38139,
		"district": "涪城区",
		"districtId": 40471,
		"address": "四川省-绵阳市-涪城区",
		"detailAddress": "绵阳市涪城区",
		"location": "104.7634203349053,31.46131438857991",
		"pictures": "http://image.hudiejx.com/rent/20230316/17e1e877ed2841eda331ce40267d5dc4.jpeg",
		"status": 2,
		"stewardStatus": 1,
		"remark": "设备机况优，机手可以熟做各种地层",
		"username": "李思℡¹⁵¹⁵⁷¹⁹⁸¹¹²",
		"statusName": null,
		"isOwn": null,
		"isBelongSteward": null,
		"distance": null,
		"isAppointed": null,
		"isApplied": null,
		"createTime": "2023-03-16 15:47:47",
		"updateTime": "2023-03-16 15:50:17"
	}, {
		"rentMachineId": 40,
		"traderId": 17,
		"stewardId": null,
		"stewardName": null,
		"stewardTel": null,
		"uniqueId": "ZL20234007",
		"title": "租赁",
		"contactPerson": "王",
		"contactTel": "15123066808",
		"typeId": 34,
		"typeName": null,
		"brandId": 1656,
		"brandName": null,
		"modelId": 1677,
		"modelName": null,
		"displayTime": 1000,
		"price": 10,
		"isFaceToFace": 1,
		"frameNumber": "",
		"province": "重庆市",
		"provinceId": 12,
		"city": "重庆城区",
		"cityId": 18038,
		"district": "大渡口区",
		"districtId": 18048,
		"address": "重庆市-重庆城区-大渡口区",
		"detailAddress": "大渡口区春晖路",
		"location": "106.48412282022434,29.481370420567968",
		"pictures": "http://image.hudiejx.com/rent/20230316/a0173485d3cd49f8aa30ac5f96b9cf8f.jpg",
		"status": 5,
		"stewardStatus": 1,
		"remark": "车况良好",
		"username": "新用户260",
		"statusName": null,
		"isOwn": null,
		"isBelongSteward": null,
		"distance": null,
		"isAppointed": null,
		"isApplied": null,
		"createTime": "2023-03-16 15:47:13",
		"updateTime": "2023-04-11 17:58:12"
	}, {
		"rentMachineId": 39,
		"traderId": 14302,
		"stewardId": null,
		"stewardName": null,
		"stewardTel": null,
		"uniqueId": "ZL20237351",
		"title": "280D",
		"contactPerson": "王",
		"contactTel": "18883810110",
		"typeId": 34,
		"typeName": null,
		"brandId": 1656,
		"brandName": null,
		"modelId": 1677,
		"modelName": null,
		"displayTime": 3000,
		"price": 0,
		"isFaceToFace": 0,
		"frameNumber": "",
		"province": "重庆市",
		"provinceId": 12,
		"city": "重庆城区",
		"cityId": 18038,
		"district": "璧山区",
		"districtId": 18043,
		"address": "重庆市-重庆城区-璧山区",
		"detailAddress": "康宁路徐工西南再制造基地",
		"location": "106.23228170278805,29.5676151369258",
		"pictures": "http://image.hudiejx.com/rent/20230225/f9b9838354f7436da5176f5dff068e74.jpg",
		"status": 2,
		"stewardStatus": 1,
		"remark": "车况较高",
		"username": "GJTA8997",
		"statusName": null,
		"isOwn": null,
		"isBelongSteward": null,
		"distance": null,
		"isAppointed": null,
		"isApplied": null,
		"createTime": "2023-02-25 19:45:43",
		"updateTime": "2023-03-21 09:47:17"
	}, {
		"rentMachineId": 38,
		"traderId": 4225,
		"stewardId": null,
		"stewardName": null,
		"stewardTel": null,
		"uniqueId": "ZL20231804",
		"title": "徐工XR240E出租",
		"contactPerson": "周先生",
		"contactTel": "18580701460",
		"typeId": 34,
		"typeName": null,
		"brandId": 1656,
		"brandName": null,
		"modelId": 1687,
		"modelName": null,
		"displayTime": 4000,
		"price": 8.5,
		"isFaceToFace": 1,
		"frameNumber": "",
		"province": "重庆市",
		"provinceId": 12,
		"city": "重庆城区",
		"cityId": 18038,
		"district": "渝北区",
		"districtId": 18055,
		"address": "重庆市-重庆城区-渝北区",
		"detailAddress": "领航路17号",
		"location": "106.66284267764753,29.74937778898376",
		"pictures": "http://image.hudiejx.com/rent/20230104/b79e590ab9c84b7a8d5a5c0963bc9501.jpg",
		"status": 3,
		"stewardStatus": 1,
		"remark": "曾庆叫大姐大姐大",
		"username": "工地包工头",
		"statusName": null,
		"isOwn": null,
		"isBelongSteward": null,
		"distance": null,
		"isAppointed": null,
		"isApplied": null,
		"createTime": "2023-01-04 14:08:29",
		"updateTime": "2023-01-04 14:11:55"
	}
]
module.exports = {
	zulinList: zulinList
}